import { render, staticRenderFns } from "./CategoryMenu.component.vue?vue&type=template&id=77be158a&scoped=true&"
import script from "./CategoryMenu.component.vue?vue&type=script&lang=ts&"
export * from "./CategoryMenu.component.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryMenu.component.vue?vue&type=style&index=0&id=77be158a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77be158a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VDialog,VIcon,VProgressCircular})
